import {default as throttle} from "lodash/throttle"

export class CategorySubnav {
  static selector = "[data-component=category-subnav]"

  constructor(el) {
    this.root = el

    const header = document.querySelector("header[data-component=header]"),
          headerRect = header.getBoundingClientRect(),
          rootRect = this.root.getBoundingClientRect()
    this.stickyBarrierY = (window.scrollY + rootRect.top) - headerRect.height
    // spacer so shifting from not-sticky to sticky doesn't create a scrolling jump
    this.stickySpacer = document.createElement("div")
    this.stickySpacer.style.width = "100%"
    this.stickySpacer.style.height = `${2 * rootRect.height}px`

    this.setup()
  }

  get menuItems() {
    return Array.from(this.root.querySelectorAll("a")).filter(x => x.closest("li") !== this.triggerLi)
  }

  // the desired y coordinate for a target section after clicking the menu item
  get desiredTop() {
    const style = window.getComputedStyle(document.documentElement),
          rem = parseFloat(style.fontSize),
          headerHeightRem = parseFloat(style.getPropertyValue("--header-height")),
          headerHeightPx = headerHeightRem * rem,
          spacerHeightPx = parseFloat(this.stickySpacer.style.height)

    // assumes all target sections are low enough to make the subnav sticky
    return headerHeightPx + spacerHeightPx + (rem / 2)
  }

  toggleOpen = ev => {
    ev.preventDefault()
    ev.stopPropagation()
    this.root.toggleAttribute("data-open")
  }

  onClickMenuItem = ev => {
    this.root.removeAttribute("data-open")
    // make an effort to improve on default "jump to anchor" browser behavior, but bail and allow
    // browser to handle it if anything goes wrong
    try {
      const target = document.querySelector((new URL(ev.target.href)).hash)
      if (target) {
        const targetRect = target.getBoundingClientRect(),
              yDelta = targetRect.top - this.desiredTop
        window.scrollBy({top: yDelta, behavior: "smooth"})
        window.history.pushState({}, "", ev.target.href)
        ev.preventDefault()
      }
    } catch {
      // nop
    }
  }

  onScroll = _ev => {
    if (window.scrollY >= this.stickyBarrierY) {
      this.root.insertAdjacentElement("beforebegin", this.stickySpacer)
      this.root.dataset.sticky = ""
    } else {
      this.stickySpacer.remove()
      this.root.removeAttribute("data-sticky")
    }
  }

  setup() {
    window.addEventListener("resize", this.onResize)
    this.onScroll()
    this.onScrollThrottle = throttle(this.onScroll, 100, {leading: true, trailing: true})
    document.addEventListener("scroll", this.onScrollThrottle)

    this.menuItems.forEach(mi => mi.addEventListener("click", this.onClickMenuItem))

    // we insert the mobile menu toggle element via JS to keep templates less repetitive
    this.triggerLi = document.createElement("li")
    this.triggerLi.dataset.action = "menu-trigger"
    const triggerA = document.createElement("a")
    triggerA.setAttribute("href", "#")
    triggerA.innerText = "Explore"
    this.triggerLi.appendChild(triggerA)
    this.triggerLi.addEventListener("click", this.toggleOpen)
    this.root.querySelector("ul").prepend(this.triggerLi)
  }
}
